import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import RHLogged from '../../../components/auth/rh'

function RHLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Transparência - Recursos Humanos" />
                <HeaderLogged />
                <Container>
                   <RHLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default RHLoggedScreen;